import { useEffect, type RefObject } from "react";

interface Escape {
  readonly capture?: boolean; readonly stop?: boolean; readonly prevent?: boolean;
  readonly nodesOnly?: boolean; readonly escaped?: () => void;
}

export function useDismiss(box: RefObject<HTMLElement | null>, open: boolean, close: () => void, how: Escape = {}): void {
  const { capture = false, stop = false, prevent = false, nodesOnly = false, escaped } = how;
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      const target = event.target instanceof Node ? event.target : null;
      if ((target !== null || !nodesOnly) && !box.current?.contains(target)) close();
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      if (prevent) event.preventDefault();
      if (stop) event.stopPropagation();
      close();
      escaped?.();
    };
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", escape, capture);
    return () => {
      document.removeEventListener("pointerdown", outside);
      document.removeEventListener("keydown", escape, capture);
    };
  }, [box, open, close, capture, stop, prevent, nodesOnly, escaped]);
}
